// This file is auto-generated. Do not edit manually.
// Generated on: 2025-09-18T12:10:51.304Z
// Generated from GraphQL schema by scripts/generateDateTimeFields.js

/**
 * Mapping of GraphQL object types to their DateTime scalar fields
 * Used by dateTimeLink to safely transform only known DateTime fields
 */
export const DATE_TIME_FIELDS_MAP = {
  "ApiKey": [
    "createdDate",
    "lastUpdatedDate"
  ],
  "ApiKeyViewModel": [
    "createdDate",
    "lastUpdatedDate"
  ],
  "CalculationDetail": [
    "completed",
    "created",
    "started"
  ],
  "DateTimeRangeFilterInput": [
    "from",
    "to"
  ],
  "IS3ObjectDto": [
    "lastModified"
  ],
  "NotificationDeliveryStatus": [
    "triggeredDate"
  ],
  "ServiceProductDetails": [
    "endDate",
    "startDate"
  ],
  "ServiceProductPeriod": [
    "endDate",
    "startDate"
  ],
  "ServiceProductPeriodInputInput": [
    "endDate",
    "startDate"
  ],
  "SessionViewModel": [
    "startTime"
  ],
  "Solution": [
    "creationTime"
  ],
  "Transaction": [
    "timestamp"
  ],
  "TransactionViewModel": [
    "timestamp"
  ]
} as const;

export type DateTimeFieldsMap = typeof DATE_TIME_FIELDS_MAP;

/**
 * Check if a field is a DateTime field for a given type
 */
export function isDateTimeField(typeName: string, fieldName: string): boolean {
  const fields = DATE_TIME_FIELDS_MAP[typeName as keyof DateTimeFieldsMap];
  return Array.isArray(fields) && fields.includes(fieldName);
}

/**
 * Get all DateTime fields for a type
 */
export function getDateTimeFields(typeName: string): readonly string[] {
  return DATE_TIME_FIELDS_MAP[typeName as keyof DateTimeFieldsMap] || [];
}

// Development-only validation
if (process.env.NODE_ENV === 'development') {
  console.log('📅 DateTime fields loaded:', Object.keys(DATE_TIME_FIELDS_MAP).length, 'types');
}
